// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 11) return "static/js/93871eaf33e12530af59.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"d8ab98f63957d0c8bc74","125":"9dca494b960bb04b0bcc","126":"967cf9b659ea9aa2cb2b"}[chunkId] + ".chunk.js";
};